export default {"src":"/_next/static/media/ShotQualityApiFirstBlock.d0c4572c.gif","height":1080,"width":1920,"blurWidth":0,"blurHeight":0};